// The ECONIC Agent screen's data (WP-SUPER-AGENT): the person's conversations (every department, the specialists' too), the specialists
// and desk agents it can talk to, and the department the conversation works in. WP-SUPER-AGENT.
import { useQuery } from "@tanstack/react-query";
import { useAssistantApi, type AgentRoster, type Thread } from "@ncp/assistant-sdk";
import { useWorkspace } from "../../app/workspace-context";
import { useDepartments } from "../departments";

export const agentKeys = {
  threads: (q: string) => ["assistant", "threads", "agent", q] as const,
  roster: ["assistant", "agent", "roster"] as const,
};

export function useAgentThreads(q = "", enabled = true) {
  const sdk = useAssistantApi();
  return useQuery<Thread[]>({ queryKey: agentKeys.threads(q), queryFn: () => sdk.agentThreads(q || null, 60), enabled, staleTime: 10_000 });
}

export function useAgentRoster() {
  const sdk = useAssistantApi();
  return useQuery<AgentRoster>({ queryKey: agentKeys.roster, queryFn: () => sdk.agentSpecialists(), staleTime: 5 * 60_000 });
}

/** The department the conversation works in: the one in force (the chip's), else the workspace's. */
export function useAgentSpace(): string | null {
  const { current } = useDepartments();
  const { workspaceKey } = useWorkspace();
  return current?.workspace ?? workspaceKey ?? null;
}
